import React, { useState } from "react";
//import PropTypes from "prop-types";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import MuiTextField from "@mui/material/TextField";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import Modal from "../components/Modal";

const TextField = styled(MuiTextField)(({ theme }) => ({
  margin: theme.spacing(1),
}));

var validationSchema = Yup.object().shape({
  email: Yup.string().email("Email inválido.").required("Complete el campo"),
});

const ModalEmail = (props) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    formik.handleReset();
    setOpen(false);
  };

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      props.resultado({
        email: values.email,
        organismoId: props.iniciador.organismoId,
        personaId: props.iniciador.personaId,
      });
      handleClose();
    },
    onReset: () => {
      //
    },
  });

  return (
    <>
      <IconButton 
        title="Agregar e-mail" 
        size="small" 
        onClick={handleOpen}
        disabled={props.tienePermisoAgregarAdjunto !== "S"}
      >
        <EmailOutlinedIcon fontSize="small" />
      </IconButton>

      <Modal open={open} handleClose={handleClose} size="sm">
        <Typography variant="cuerpo" paragraph>
          {props.iniciador.nombre}
        </Typography>
        <form
          id="formEmail"
          name="formEmail"
          onSubmit={formik.handleSubmit}
          onReset={formik.handleReset}
          noValidate
          autoComplete="off"
        >
          <Grid container>
            <Grid item lg={12} xs={12}>
              <TextField
                id="email"
                name="email"
                label="E-mail"
                variant="outlined"
                size="small"
                margin="dense"
                fullWidth
                value={formik.values.email}
                onChange={formik.handleChange}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
              />
            </Grid>
          </Grid>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <Button sx={{ m: 1 }} variant="verde" type="submit">
              {"Agregar"}
            </Button>
            <Button sx={{ m: 1 }} variant="plata" onClick={handleClose}>
              {"Cancelar"}
            </Button>
          </Box>
        </form>
      </Modal>
    </>
  );
};

export default ModalEmail;
